enum NotFoundRoutesEnum {
  NotFoundPage = '/not-found',
}

export default NotFoundRoutesEnum;
